<p class="homeText">{{homeText}}</p>
